import { Badge } from '@mantine/core'
import { FormattedMessage } from 'react-intl'

type DeviceTypeBadgeProps = {
  isJetson?: boolean
}

export const DeviceTypeBadge = ({ isJetson }: DeviceTypeBadgeProps) => {
  if (isJetson === undefined) {
    return (
      <Badge size="sm" color="gray.5">
        <FormattedMessage id="devices.type.unknown" />
      </Badge>
    )
  }

  if (isJetson) {
    return (
      <Badge size="sm" color="green.7">
        <FormattedMessage id="devices.type.jetson" />
      </Badge>
    )
  }

  return (
    <Badge size="sm" color="blue.6">
      <FormattedMessage id="devices.type.server" />
    </Badge>
  )
}
